import React from "react";
import SearchIcon from "../../../../img/search-icon.png";
import backIcon from "../../../../img/Arrow.png";
import downChevronIcon from "../../../../img/chevron-down.png";
import ChangeCategory from "./ChangeCategory";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openCatDD, closeCatDD } from "../../../../Redux/Reducer/dropdown";
const Titlebar = ({ title }) => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.dropdown.categoryDropdown);
  const dropdownHandler = () => {
    if (show) {
      dispatch(closeCatDD());
      return;
    }
    dispatch(openCatDD());
  };
  return (
    <>
      <ChangeCategory />
      <div
        style={{ zIndex: "50000" }}
        className="fixed-top d-flex align-items-center transition text-orange bg-white plp-titlebar"
      >
        <Link to="/home" className="text-center my-auto plpbkicn">
          <img src={backIcon} />
        </Link>
        <div
          className="w-100 my-auto overflow-hidden"
          onClick={dropdownHandler}
        >
          <h2>{title}</h2>
          <h5>
            View all categories
            <img src={downChevronIcon} className="plpchevron" />
          </h5>
        </div>

        <Link
          to="/search"
          className="text-center d-flex justify-content-evenly my-auto ms-auto "
          style={{ paddingLeft: "8px" }}
        >
          <img src={SearchIcon} className="d-block" />
        </Link>
      </div>
    </>
  );
};

export default Titlebar;
